import apiClient from '@/lib/apiClient'
import { RefuseApplication, UpdateStage } from '@/schemas/application.schema'
import { IdResponseDto } from '@/shared/domain/entities/common.entity'

export const applicationService = {
  refuseApplication: async (applicationId: string, data: RefuseApplication): Promise<IdResponseDto> => {
    const response = await apiClient.put<IdResponseDto>(`applications/${applicationId}/refuse-application`, data)
    return response.data
  },
  updateStage: async (applicationId: string, data: UpdateStage): Promise<IdResponseDto> => {
    const response = await apiClient.put<IdResponseDto>(`applications/${applicationId}/update-stage`, data)
    return response.data
  },
}
